import { Grid, GridProps } from '@mui/material'
import React, { ReactNode } from 'react'

interface ExtendedGrid2Props extends GridProps {
  children: ReactNode
  spacing?: number | { mobile?: number; tablet?: number; desktop?: number }
}

export const GridContainer: React.FC<ExtendedGrid2Props> = ({ children, spacing = { mobile: 2, tablet: 2, desktop: 2 }, ...props }) => {
  return (
    <Grid container spacing={spacing} {...props}>
      {children}
    </Grid>
  )
}
